import { createLogic } from 'redux-logic';
import { normalize, schema } from 'normalizr';
import { get, map } from 'lodash';

// Action Types
const FETCH = '@@app/recipesSimilar/FETCH';
const FETCH_SUCCESS = '@@app/recipesSimilar/FETCH_SUCCESS';
const FETCH_ERROR = '@@app/recipesSimilar/FETCH_ERROR';

// Initial State
const initialState = {
  entities: {},
  result: {},
  isLoading: false,
};

// Observables
const fetchRecipesSimilarLogic = createLogic({
  type: FETCH,
  processOptions: {
    successType: FETCH_SUCCESS,
    failType: FETCH_ERROR,
  },
  process({ action, httpClient }) {
    const { payload } = action;

    return httpClient
      .get(`/v1/voome/recipes/${payload.recipeId}/similar`, {
        params: { voomeProductId: payload.voomeProductId },
      })
      .then(({ data }) => {
        const recipes = new schema.Entity('recipes');
        return { ...normalize(data, [recipes]), recipeId: payload.recipeId };
      });
  },
});

export const recipesSimilarLogic = [fetchRecipesSimilarLogic];

// Selectors
export const selectRecipesSimilar = ({ recipesSimilar }, recipeId) => {
  const recipeIds = get(recipesSimilar, ['result', recipeId], []);
  return map(recipeIds, id => {
    return get(recipesSimilar, ['entities', 'recipes', id]);
  });
};

// Action Creators
export function fetchRecipesSimilar(recipeId, voomeProductId) {
  return { type: FETCH, payload: { recipeId, voomeProductId } };
}

// Reducer
export default function recipesSimilarReducer(
  state = initialState,
  action = {}
) {
  const { type, payload } = action;

  switch (type) {
    case FETCH:
      return {
        ...state,
        isLoading: true,
      };

    case FETCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        entities: {
          recipes: {
            ...state.entities.recipes,
            ...payload.entities.recipes,
          },
        },
        result: {
          ...state.result,
          [payload.recipeId]: payload.result,
        },
      };

    default:
      return { ...state };
  }
}



// WEBPACK FOOTER //
// ./src/logic/recipesSimilar.js